import { ChangeDetectionStrategy, Component, inject, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { appBrandConfig } from '../../config/app-brand.config';
import { AuthSessionFacade } from '../../auth/auth-session.facade';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-topbar',
  imports: [CommonModule, MenuModule, ButtonModule],
  templateUrl: './app-topbar.html',
  styleUrl: './app-topbar.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'topbar-host',
  },
})
export class AppTopbar {
  private readonly authFacade = inject(AuthSessionFacade);

  protected readonly brand = appBrandConfig;
  protected readonly user = this.authFacade.user;
  protected readonly showMenu = signal<boolean>(false);

  readonly toggleSidebar = output<void>();

  protected readonly menuItems = [
    {
      label: 'My Profile',
      icon: 'pi pi-user',
      routerLink: '/profile',
    },
    { separator: true },
    {
      label: 'Sign Out',
      icon: 'pi pi-sign-out',
      command: () => this.onLogout(),
    },
  ];

  protected onToggleMenu(): void {
    this.toggleSidebar.emit();
  }

  protected onAvatarClick(event: Event): void {
    this.showMenu.update((v) => !v);
  }

  protected onLogout(): void {
    void this.authFacade.logout();
  }
}
